export default __webpack_public_path__ + "static/media/MasterKYRHK_EnglishVO_EngSub.910735de.mp4";